import Cookies from 'js-cookie';

export const USER_LOCALE_COOKIE = 'user_locale_preference';

/**
 * Gets the user's selected country/currency preference for the current browsing session.
 */
export const getSessionLocalePreference = (): string | undefined => {
  return Cookies.get(USER_LOCALE_COOKIE);
};

/**
 * Sets the user's country/currency preference as a session cookie.
 * Without an `expires` or `maxAge` parameter, the cookie automatically expires
 * when the user closes their browser session.
 */
export const setSessionLocalePreference = (countryCode: string): void => {
  Cookies.set(USER_LOCALE_COOKIE, countryCode.toLowerCase(), {
    path: '/',
    sameSite: 'lax',
  });
};

/**
 * Clears the session preference.
 */
export const clearSessionLocalePreference = (): void => {
  Cookies.remove(USER_LOCALE_COOKIE, { path: '/' });
};
